import "./styles.scss";
import "primeicons/primeicons.css";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.css";
import "primeflex/primeflex.css";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import useForm from "../../../hooks/useForm";
import { InputText } from "primereact/inputtext";
import { SideMenu } from "../../../components/SideMenu";
import { MultiSelect } from "primereact/multiselect";

import { CLIENTS_GET } from "../../../API/clientApi";
import { USERS_GET } from "../../../API/userApi";
import { CAMPAIN_POST } from "../../../API/campainApi";

export function NewCampain() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  let newUsers = [];
  const [users, setUsers] = useState([]);
  const [usersTransformed, setUsersTransformed] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState(null);

  const [clients, setCLients] = useState([]);

  const name = useForm();
  const smsRecebida = useForm();
  const smsSucesso = useForm();
  const smsFalha = useForm();
  const client = useForm();

  const token = window.localStorage.getItem("token");

  useEffect(() => {
    async function getUsers() {
      setLoading(true);
      setError(null);

      const { url, options } = USERS_GET(token);

      const usersResponse = await fetch(url, options);
      const usersJson = await usersResponse.json();

      setUsers(usersJson.data.data);

      setLoading(false);
    }

    getUsers();
  }, [token]);

  useEffect(() => {
    if (loading === true && users) {
      newUsers = users.map((user) => {
        return {
          name: user.name,
          code: user.id,
        };
      });

      setUsersTransformed(newUsers);
    }
  }, [users]);

  useEffect(() => {
    async function getClients() {
      setLoading(true);
      setError(null);

      const { url, options } = CLIENTS_GET(token);

      const clientsResponse = await fetch(url, options);
      const clientsJson = await clientsResponse.json();

      setCLients(clientsJson.data.data);

      setLoading(false);
    }

    getClients();
  }, [token]);

  async function handleSubmit(event) {
    event.preventDefault();

    const { url, options } = CAMPAIN_POST(
      {
        name: name.value,
        sms_recebido: smsRecebida.value,
        sms_sucesso: smsSucesso.value,
        sms_falha: smsFalha.value,
        fk_id_client: Number(client.value),
        users: selectedUsers.map((user) => {
          return {
            fk_id_user: user.code,
          };
        }),
      },
      token
    );

    try {
      setLoading(true);

      const campainResponse = await fetch(url, options);

      if (!campainResponse.ok) {
        setError(
          "Houve um erro ao enviar os dados, contate o suporte ou tente mais tarde."
        );
      }

      setLoading(false);

      navigate("/campain");
    } catch {
      setError(
        "Houve um erro ao enviar os dados, contate o suporte ou tente mais tarde."
      );
    } finally {
      setLoading(false);
    }
  }

  function handleChange(event) {
    setSelectedUsers(event.value);
  }
  return (
    <>
      <div>
        <SideMenu />
      </div>

      <div className="container fadeIn">
        <div className="row">
          <div className="col-md-12">
            <div className="header">
              <div>
                <i className="fas fa-business-time"></i>
                <h2>Campanha</h2>
              </div>
            </div>
          </div>
        </div>

        <div className="formContainer">
          <h2>Cadastro de Nova Campanha</h2>
          {error && <p>{error}</p>}
          <form className="row" onSubmit={handleSubmit}>
            <div className="col-md-12 form-group">
              <label htmlFor="name">Nome*</label>
              <InputText
                id="name"
                name="name"
                {...name}
                className="form-control"
              />
            </div>

            <div className="col-md-12 form-group">
              <label htmlFor="profile">Cliente*</label>
              <br />
              <select
                name="client"
                id="client"
                {...client}
                className="form-control"
                required
              >
                <option value="#">Selecione</option>
                {clients.map((client) => {
                  return (
                    <option value={client.id} key={client.id}>
                      {client.name}
                    </option>
                  );
                })}
              </select>
            </div>

            <div className="col-md-12 form-group">
              <label htmlFor="profile">Usuarios para esta campanha*</label>
              <br />
              {loading ? (
                <input
                  type="text"
                  placeholder="Carregando Usuarios.."
                  className="form-control"
                />
              ) : (
                <MultiSelect
                  value={selectedUsers}
                  options={usersTransformed}
                  optionLabel="name"
                  onChange={handleChange}
                  required
                  placeholder="Selecione os Usuários desta campanha."
                  style={{ width: "100%" }}
                  
                />
              )}
              <br />
            </div>

            <div className="col-md-12 text-center">
              <h5>Mensagens de SMS</h5>
              <hr />
            </div>

            <div className="col-md-4 form-group">
              <label htmlFor="name">Recebida</label>
              <InputText
                id="name"
                name="name"
                {...smsRecebida}
                className="form-control"
                required
              />
            </div>

            <div className="col-md-4 form-group">
              <label htmlFor="name">Sucesso</label>
              <InputText
                id="name"
                name="name"
                {...smsSucesso}
                className="form-control"
                required
              />
              <cite style={{fontSize: ".8rem", color: "gray"}}>Utilize o texto especial "[urllink]" para escolher a localização do link</cite>
            </div>

            <div className="col-md-4 form-group">
              <label htmlFor="name">Falha</label>
              <InputText
                id="name"
                name="name"
                {...smsFalha}
                className="form-control"
                required
              />
            </div>

            <div className="col-md-12 buttonBox">
              <Link to="/campain">
                <button className="cancel">Cancelar</button>
              </Link>
              {loading ? (
                <button type="submit" disabled className="register">
                  Cadastrado...
                </button>
              ) : (
                <button type="submit" className="register">
                  Cadastrar
                </button>
              )}
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
